<template>
<div class="row" v-if="showNotification">
  <div class="col-12">
      <card>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h3>{{$t('assessments.message_title')}}</h3>
                <p>{{$t('assessments.message_info')}}</p>
                <router-link class="btn btn-primary ml-2" :to="{ name: 'assessments' }">
                  {{$t('assessments.fill')}}
                </router-link>
              </div>
            </div>
          </div>
      </card>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      value: [this.$route.name]
    };
  },
  computed: {
    showNotification() {
      return this.$route.name == 'repairs';
    }
  }
}
</script>
